<div fxLayout="column" style="padding:15px;">

    <mat-card>
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column">

            <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:50px;">

                <div fxLayout="row" fxLayoutGap="20px" fxFlex="grow" ngStyle.md="width:90%" ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:90%">
                    <div fxFlexAlign="center">Γρήγορη Αναζήτηση</div>
                    <mat-form-field>
                        <mat-label>
                            Αναζήτηση
                        </mat-label>
                        <input matInput (keydown)="search($event.target.value)">
                    </mat-form-field>


<!--                    <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch" fxFlex.lt-md="100">-->
<!--                        <button ngStyle.lt-md="width:100%;"-->
<!--                                style="background: var(&#45;&#45;primary); color:white; font-weight: normal; vertical-align: middle; border-radius: 50px;"-->
<!--                                mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">-->
<!--                            Ενέργειες-->
<!--                            &nbsp;-->
<!--                            <mat-icon style="vertical-align: middle; color:white;">-->
<!--                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}-->
<!--                            </mat-icon>-->
<!--                        </button>-->

<!--                        <mat-menu #menu="matMenu">-->

<!--                            <mat-list class="menuList">-->
<!--                                <mat-list-item class="menuList" >-->
<!--                                    <button mat-menu-item (click)="exportToExcel()">-->
<!--                                        <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε xlsx-->
<!--                                    </button>-->
<!--                                </mat-list-item>-->
<!--                            </mat-list>-->

<!--                        </mat-menu>-->
<!--                    </div>-->
                    <!--      -->
                </div>


                <div fxLayout="row" fxFlex="grow" style="margin-top:20px;" ngStyle.md="width:90%" ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:90%">


                    <div fxLayout="column" fxFlex="grow" #tableContainer>
                        <!--        Table     -->
                        <mat-table  [dataSource]="dataSource" matSort style="width:100%;">


                            <ng-container matColumnDef="accepted">
                                <mat-header-cell  fxFlex="15" *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Email παραλήπτη επιτυχίας
                                </mat-header-cell>
                                <mat-cell fxFlex="15"  *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.accepted !=='null'? record.accepted : '-'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="rejected">
                                <mat-header-cell fxFlex="15"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Email παραλήπτη αποτυχίας
                                </mat-header-cell>
                                <mat-cell  fxFlex="15" *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.rejected !=='null'? record.rejected : '-'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="subject">
                                <mat-header-cell fxFlex="20"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Θέμα
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.subject ? record.subject : '-'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="messageId">
                                <mat-header-cell fxFlex="20"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Message Id
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.messageId ? record.messageId : '-'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="envelope">
                                <mat-header-cell fxFlex="20" *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Envelope
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.envelope ? record.envelope : '-'}} </mat-cell>
                            </ng-container>


                            <ng-container matColumnDef="action">
                                <mat-header-cell fxFlex="5" *matHeaderCellDef  mat-sort-header fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
                                <mat-cell fxFlex="5" fxLayoutAlign="center center center" *matCellDef="let record"
                                           >

                                <mat-icon *ngIf="+record.action === 1" style="color: green;">check</mat-icon>
                                <mat-icon *ngIf="+record.action === 0" style="color: red;">cancel</mat-icon>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="action_date">
                                <mat-header-cell  *matHeaderCellDef mat-sort-header  fxLayoutAlign="start center center"> Ημ. Ενέργειας
                                </mat-header-cell>
                                <mat-cell  *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.action_date}} </mat-cell>
                            </ng-container>





                            <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
                            <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>
                        </mat-table>

                        <div *ngIf="dataSource.data.length === 0" fxLayoutAlign="center center center" style="margin-top:50px; margin-bottom: 50px;">
                            Δεν υπάρχουν εγγραφές
                        </div>
                    </div>
                </div>
                <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                    <app-loading></app-loading>
                </div>
                <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                    <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[10,20, 50, 100, 200, 400]">
                    </mat-paginator>
                </div>
                <!--        -->

            </div>

        </mat-card-content>
    </mat-card>

</div>
